import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { PaginationResponseDTO } from 'src/dto/base.dto';
import { FunderInvestmentFilterDTO } from 'src/dto/funder-investment.dto';
import { IInvestmentDetail, IInvestmentFilter } from 'src/interfaces/mortgage-deal/investment';
import { HttpService } from 'src/services/http.service';

export interface IFunderInvestmentStore {
  listInvestments: IInvestmentDetail[];
  total: number;
  currentPage: number;
  loadInvestmentList(filter: IInvestmentFilter): Promise<void>;
  dispose(): void;
}

export class FunderInvestmentStore implements IFunderInvestmentStore{
  listInvestments: IInvestmentDetail[] = [];
  total = 0;
  currentPage = 0;
  constructor(private readonly http: HttpService){
    makeAutoObservable(this, {
      listInvestments: observable,
      total: observable,
      currentPage: observable,
      dispose: action.bound
    })
  }
  public async loadInvestmentList(filter: IInvestmentFilter): Promise<void> {
    const dto = new FunderInvestmentFilterDTO({
      ...filter
    });

    const rs: PaginationResponseDTO<IInvestmentDetail[]> = await this.http.request(dto);
    if(rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS){
      runInAction(()=>{
        if(rs.data && rs.data.length){
          this.listInvestments = rs.data;
          this.currentPage = rs.pageNumber || 1,
          this.total = rs.totalRecords || 0;
        }
      });
    }
  }
  public dispose(): void{
    this.listInvestments = [];
  }
}